var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewEr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m13.4127.463533c-.8818-.4847429-1.9441-.4847432-2.8259 0l-8.22547 4.521507c-.96193.52876-1.561525 1.5522-1.561525 2.66534v8.69922c0 1.1131.599595 2.1366 1.561525 2.6653l8.22547 4.5215c.8818.4848 1.9441.4848 2.8259 0l8.2255-4.5215c.9619-.5287 1.5616-1.5522 1.5616-2.6653v-8.69922c0-1.11314-.5997-2.13658-1.5616-2.66534zm-2.2585 14.416967v1.6627h-6.78467v-8.95489h6.62227v1.66271h-4.60665v1.94478h4.06825v1.6121h-4.06825v2.0726zm8.8633 1.6628-2.1904-.0005-1.6829-2.4965-.0047.0003c-.0304.001-.0594.0021-.0897.0021h-1.6336v-1.65h1.5217c.6254 0 1.0929-.1388 1.402-.4157.3079-.2769.463-.6506.463-1.1451 0-.4946-.1545-.87861-.463-1.15151-.3086-.27289-.7761-.40934-1.402-.40934h-1.5217v-1.68862h1.6336c.7838 0 1.4598.12955 2.0279.39035.5681.26023 1.0058.63272 1.3149 1.11922.3091.48591.463 1.0749.463 1.7399 0 .6649-.1546 1.2384-.463 1.7202-.3091.4819-.7474.8504-1.3149 1.1066l-.0045.0021-.0026.001-.0023.001-.0036.0014-.0044.002zm-8.2896-8.95487h1.9527v8.95487h-1.9527z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEr);
export default __webpack_public_path__ + "static/media/new-er.fb3d7937687c026a0117583a2a78db88.svg";
export { ForwardRef as ReactComponent };